module.exports = __webpack_public_path__ + "img/48.e2b56683.jpg";